import MediaType from "nexia_mobile/framework/media_type";

export default class Link {
  constructor(attrs, options) {
    _.extend(this, attrs);
    this.options = options || {};

    if (!this.method) {
      this.method = "";
    }
    if (!this.data) {
      this.data = {};
    }
    if (!this.data._links) {
      this.data._links = {};
    }
    if (!this.data._links.self) {
      this.data._links.self = { href: this.href };
    }
  }

  getHref() {
    return this.href;
  }

  isTemplated() {
    return Boolean(this.templated);
  }

  isPostLink() {
    return this.method === "POST";
  }

  isPutLink() {
    return this.method === "PUT";
  }

  hasData() {
    return Boolean(this.data);
  }

  getData() {
    return this.data;
  }

  hasType(mediaType) {
    if (_.isString(mediaType)) {
      return this.type === mediaType;
    } else {
      return Boolean(this.type);
    }
  }

  getCollectionItemType() {
    if (this.type !== MediaType.COLLECTION) {
      return null;
    }
    if (this.data) {
      return this.data.item_type;
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/framework/link.js